import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isInvalid } from 'redux-form';

import LineChartComponent from './Component';

import { getDistributionsType } from 'store/form/distributions/selectors';
import { DISTRIBUTIONS } from 'store/form/names';

class LineChartContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      canvasWidth: 0,
      canvasHeight: 0
    };

    this.captureContainerProps = container => {
      if (container) {
        this.setState({
          canvasWidth: container.clientWidth,
          canvasHeight: container.clientHeight
        });
      }
    };
  }

  render () {
    return (
      <div ref={this.captureContainerProps} className="flex flex-grow">
        {this.state.canvasWidth && this.state.canvasHeight &&
          <LineChartComponent
            {...this.props}
            canvasWidth={this.state.canvasWidth}
            canvasHeight={this.state.canvasHeight}
            drawZAxis={this.props.drawZAxis}
          />
        }
      </div>
    );
  }
}

LineChartContainer.propTypes = {
  drawZAxis: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  drawZAxis: getDistributionsType(state) === 'normal',
  isInvalidForm: isInvalid(DISTRIBUTIONS)(state)
});

export default connect(mapStateToProps)(LineChartContainer);
